var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('NavigationPopOver',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"reference",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"dark":"","icon":""}},on),[_c('v-icon',[_vm._v("apps")])],1)]}}],null,false,4086333560)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }